import InnerSection from "../components/team-light/inner-section";

export default function TeamLight() {
	return <InnerSection />;
}